export default {
  id: 'invoice-create-wizard',
  title: 'Create Invoice',
  category: 'Admin',
  summary: 'Choose Labor, Travel, or Other to start the correct invoice creation workflow.',
  overview: 'Different invoice types pull from different source data. Selecting the right type ensures line items are built from approved time or expenses correctly. Labor invoices for prime cost-plus projects open a cost-plus funding breakdown on the invoice details page after creation.',
  howItWorks: [
    'Labor builds invoices from approved billable hours. On T&M contracts this uses labor rates; on prime cost-plus it feeds the cost-plus summary (direct, indirect, and fee).',
    'Travel builds invoices from approved travel expense amounts that are customer-billable.',
    'Other supports manually composed or miscellaneous billable charges.'
  ],
  actions: [
    {
      name: 'Select Labor',
      description: 'Opens the labor invoice builder to select periods, projects, and time entries to bill.'
    },
    {
      name: 'Select Travel',
      description: 'Opens the travel invoice builder for reimbursable/billable travel costs.'
    },
    {
      name: 'Select Other',
      description: 'Opens the miscellaneous invoice builder for non-labor/non-travel charges.'
    }
  ],
  tips: [
    'If expected hours are missing, confirm timesheets are approved and charge codes are billable under the correct contract rates.',
    'For cost-plus labor invoices, make sure project funding obligations and Labor/Fee pairs are set up first.'
  ],
  related: ['invoices', 'funding-obligations', 'contracts', 'expenses']
};



// WEBPACK FOOTER //
// ./client/help/content/invoice-create-wizard.js